import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import * as Yup from 'yup';
import { PUBLIC_HOLIDAY_MANAGEMENT_URL, GET_PUBLIC_HOLIDAY_URL, UPDATE_PUBLIC_HOLIDAY_URL, DATE_DISPLAY_FORMAT, LAYOUT_TYPE } from '../../App/AppSettings';
import Layout from '../../Layout';
import { SUCCESS, ERROR } from '../../Localization';
import { fetchRequest, getParams, navigateTo } from '../../Shared/Actions';
import { FIELD_SIZE } from '../../Shared/Constants';
import { DateInput, SMARTForm, Text, withSMARTWrapper } from '../../Shared/Forms';
import { DEFAULT_TEXT, DEFAULT_NAMESPACE } from '../../Shared/Constants/LanguageKeys.js';
import { toastError, toastSuccess } from '../../Shared/Forms/Toaster.js';
import history from '../../Shared/History';
import PageFooter from '../../Shared/PageFooter';
import { withLoader } from '../../Shared/Loading';

const FORM_CONTEXT = "PublicHolidayConfig";
const NEXT_URL = '/SystemConfig/PublicHoliday';

const FORM_INITIAL_VALUES = {
    Date: '',
    Title: '',
    Remarks: ''
};

class PublicHolidayUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            values: FORM_INITIAL_VALUES
        };

        if (history.location.state) {
            this.state = {
                Id: history.location.state.ID
            }
        }
    }

    async componentDidMount() {
        const { state } = history.location;
        const { loader } = this.props;

        if (state && state.ID) {
            loader.start();
            const response = await fetchRequest(GET_PUBLIC_HOLIDAY_URL, getParams({ Id: this.state.Id }), false);
            loader.done();

            const { IsSuccess, Data, Messages } = response.body;
            
            if (response.success && IsSuccess) {
                this.setState({ 
                    values: Data 
                });
            }
            else {
                loader.error(Messages);
            }
        }
        else {
            toastError(this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_SERVERUNREACHABLE, ERROR.SERVER_UNREACHABLE));
        }
    }

     // Fn: Get Yup form validations
     getFormValidations = () => {
        return Yup.object().shape({
            Date: Yup.string()
                .required(this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_REQUIRED, ERROR.REQUIRED)),
            Title: Yup.string()
                .required(this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_REQUIRED, ERROR.REQUIRED))
                .min(0, this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_MINLENGTH, ERROR.MIN_LENGTH_LIMIT))
                .max(255, this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_MAXLENGTH, ERROR.MAX_LENGTH_LIMIT)),
            Remarks: Yup.string()
                .min(0, this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_MINLENGTH, ERROR.MIN_LENGTH_LIMIT))
                .max(255, this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_MAXLENGTH, ERROR.MAX_LENGTH_LIMIT))
        });
    }

    // Fn: Massage form values to be submitted
    massageValues = (values, submitPlainForm) => {
        // Add Id
        values.Id = this.state.Id;
        submitPlainForm();
    }

    submitCallback = ({ response }) => {
        if (response.success) {
            const { IsSuccess, RedirectURL, MessageLanguageKey, Message } = response.body;
            if (IsSuccess) {
                if (RedirectURL) {
                    navigateTo(RedirectURL, "");
                } else {
                    navigateTo(NEXT_URL, "");
                }

                toastSuccess(this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_SUCCESS_TITLE_UPDATEPUBLICHOLIDAY, SUCCESS.UPDATE_SUCCESS), DEFAULT_TEXT.PUBLIC_HOLIDAY);
            }
            else {
                toastError(this.props.getMessage(MessageLanguageKey, Message));
            }
        } else {
            toastError(this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_DEFAULTSTATIC_ERROR_TITLE_SERVERUNREACHABLE, ERROR.SERVER_UNREACHABLE));
        }
    }

    render() {
        return (
            <React.Fragment>
                <Layout type={LAYOUT_TYPE.FORM} title=
                    {this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_CONTENT_TITLE_UPDATEPUBLICHOLIDAY, DEFAULT_TEXT.UPDATE_PUBLIC_HOLIDAY)}>
                    <SMARTForm
                        formContext={FORM_CONTEXT}
                        formValues={this.state.values}
                        validationSchema={this.getFormValidations()}
                        validateOnSubmit={true}
                        serverURL={UPDATE_PUBLIC_HOLIDAY_URL}
                        isDummy={false}
                        submitCallback={this.submitCallback}
                    >
                        {({ values, errors, onChange, onChangeField, submitPlainForm }) => (
                            <React.Fragment>
                                <Row className="body-content admin-content-wrapper">
                                    <Col>
                                        <DateInput
                                            name="Date"
                                            value={values.Date}
                                            placeholder={this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_FORM_PLACEHOLDER_DATE, DEFAULT_TEXT.DATE)}
                                            onChangeField={onChangeField}
                                            time={false}
                                            date={true}
                                            min="1990/01/01"
                                            format={DATE_DISPLAY_FORMAT.DATE}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label={this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_FORM_TITLE_DATE, DEFAULT_TEXT.DATE)}
                                            error={errors.Date}
                                            required
                                        />
                                        <Text
                                            name="Title"
                                            value={values.Title}
                                            placeholder={this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_FORM_PLACEHOLDER_NAME, DEFAULT_TEXT.NAME_OF_PH)}
                                            onChange={onChange}
                                            minLength={0}
                                            maxLength={140}
                                            inputSize={FIELD_SIZE.LARGE}
                                            label={this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_FORM_TITLE_PUBLICHOLIDAY, DEFAULT_TEXT.PUBLIC_HOLIDAY)}
                                            error={errors.Title}
                                            required
                                        />
                                        <Text
                                            name="Remarks"
                                            value={values.Remarks}
                                            placeholder={this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_FORM_PLACEHOLDER_REMARKS, DEFAULT_TEXT.REMARKS)}
                                            onChange={onChange}
                                            minLength={0}
                                            maxLength={140}
                                            inputSize={FIELD_SIZE.LARGE}
                                            label={this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_FORM_TITLE_REMARKS, DEFAULT_TEXT.REMARKS)}
                                        />
                                    </Col>
                                </Row>
                                <PageFooter type={LAYOUT_TYPE.FORM}>
                                    <Button color="backward" size="sm" type="button" onClick={() => navigateTo(PUBLIC_HOLIDAY_MANAGEMENT_URL)}>
                                        {this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_NAVIGATION_BUTTON_BACK, DEFAULT_TEXT.BACK)}
                                    </Button>
                                    <Button color="forward" size="sm" type="button" onClick={() => this.massageValues(values, submitPlainForm)}>
                                        {this.props.getStaticText(DEFAULT_NAMESPACE.GLOBAL_PUBLICHOLIDAYSTATIC_NAVIGATION_BUTTON_UPDATE, DEFAULT_TEXT.UPDATE)}
                                    </Button>
                                </PageFooter>
                            </React.Fragment>
                        )}
                    </SMARTForm>
                </Layout>
            </React.Fragment>
        );
    }
}

export default withSMARTWrapper(withLoader(PublicHolidayUpdate));

